module.exports = __webpack_public_path__ + "static/media/settings.9648ca2d.svg";